import {
  getBlackbox,
  useLoadIovation,
  waitForPrototypeAvailability,
} from '@varo/expo-iovation';
import { useEffect } from 'react';
import { RETRY_INTERVAL } from 'shared/constants/auth';
import { isWeb } from 'shared/constants/platform';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

function useIovationToken() {
  const { iovationError } = useLoadIovation();

  const fetchIovationToken = async (attempt = 0): Promise<string> => {
    if (isWeb) {
      await waitForPrototypeAvailability(global, 'IGLOO');
      await waitForPrototypeAvailability(global.IGLOO, 'getBlackbox');
    }
    try {
      const blackboxData = (await getBlackbox()) as string;

      if (!blackboxData) {
        throw new Error('Empty response');
      }

      return blackboxData;
    } catch (error) {
      if (attempt < 3) {
        logBreadcrumb({
          level: 'error',
          category: 'Iovation Fetch Error',
          message: error instanceof Error ? error.message : String(error),
        });
        await delay(RETRY_INTERVAL);
        return fetchIovationToken(attempt + 1);
      }
      return '';
    }
  };

  useEffect(() => {
    if (iovationError) {
      logBreadcrumb({
        level: 'error',
        category: 'Iovation Error',
        message: 'iovationError',
      });
    }
  }, [iovationError]);

  return { fetchIovationToken };
}

export default useIovationToken;
